<template>
  <div class="box">
    <ul>
      <li
        v-for="(item, index) in dateList"
        :key="index"
        @click="handleChangeDateType(index)"
        :style="dateType === index + 1 ? 'background-color:#033ec7' : ''"
      >
        {{ item.date }}
      </li>
    </ul>
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";

export default {
  name: "dateBox",

  data() {
    return {
      dateList: [
        {
          date: "日",
          type: 1,
        },
        {
          date: "月",
          type: 2,
        },
        {
          date: "年",
          type: 3,
        },
      ],
    };
  },
  computed: {
    ...mapState(["dateType"]),
  },
  methods: {
    ...mapMutations(["changeDateType"]),
    // 修改年月日
    handleChangeDateType(typeIndex) {
      this.changeDateType(typeIndex + 1);
      console.log(typeIndex + 1);
    },
  },
};
</script>

<style scoped>
.box {
  color: #00fff8;
  align-self: flex-end;
	display: flex;
	justify-content: center;
}
ul {
  list-style: none;
  overflow: hidden;
  margin: 0 !important;
}
ul li {
  float: left;
  border-radius: 7px;
  padding: 6px 30px;
  background: #081273;
  cursor: pointer;
}

</style>
